import FormFunc from "../../../utils/FormFunc";

export default function SingleInfo({
  title,
  name,
  value,
  input,
  handleEvents,
}) {
  let element = "";
  if (input?.type === "text") {
    element = (
      <FormFunc.InputText
        data={{
          name: name,
          addClass: "col s12",
          defaultValue: value,
          required: input?.required,
          disabled: false,
        }}
        events={handleEvents}
      />
    );
  } else if (input?.type === "date") {
    element = (
      <FormFunc.InputDate
        data={{
          id: input?.id,
          name: name,
          addClass: "col s12",
          defaultValue: value,
          disabled: false,
        }}
        events={handleEvents}
      />
    );
  } else if (input?.type === "select") {
    element = (
      <FormFunc.SingleSelect
        data={{
          id: input?.id,
          name: name,
          options: input?.options ?? [],
          addClass: "col s12",
          optionName: input?.optionName ?? "name",
          optionValue: input?.optionValue ?? "value",
          optionTitle: input?.optionTitle ?? "---",
          optionGroup: input?.optionGroup ?? false,
          defaultValue: value,
          required: input?.required,
          disabled: false,
          style: { width: "100%" },
        }}
        filters={input?.filters}
        events={handleEvents}
      />
    );
  } else {
    element = (
      <div style={{ height: "2rem", lineHeight: "28px" }}>
        {value !== "" ? value : "-"}
      </div>
    );
  }
  return (
    <div className="col s12" key={"single-info-" + name}>
      <div
        className="col s4"
        style={{ color: "#656262", fontWeight: "bold", lineHeight: "28px" }}
      >
        {title}
        {input?.required ? <span style={{ color: "red" }}> *</span> : ""}
      </div>
      <div className="col s8" style={{ color: "#6d6969" }}>
        {element}
      </div>
    </div>
  );
}
